import {SettingsCustomFieldsPagesEnum} from '../../../../models/url/settingsUrlModel';
import {baseMethods, GetCustomField, ResultType, ResultTypesEnum, StringResult} from './internal';

export const inboxType: ResultType = {
  name: ResultTypesEnum.INBOX,
  properties: {
    id: StringResult,
    name: StringResult,
  },
  methods: {
    get_custom_field: new GetCustomField(SettingsCustomFieldsPagesEnum.INBOXES),
    ...baseMethods,
  },
};
